import * as S from "./styled";

export const Filter = ({ children }) => {
  return <S.FilterBarContainer>{children}</S.FilterBarContainer>;
};
